// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__API-s","margin-right":"Footer_margin-right__awkVD","links":"Footer_links__4o9WH","footer-text":"Footer_footer-text__9-2Et"};